import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const quickLinks = [
  { to: '/', label: '首页' },
  { to: '/category', label: '电视剧分类' },
  { to: '/news', label: '影视资讯' },
  { to: '/search', label: '站内搜索' },
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200 mt-16">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-clapperboard-fill"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">上司的老婆</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              专注电视剧剧情介绍、角色解析与影视行业动态的内容平台，帮助剧迷全面了解每一部好剧。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">剧集分类</h4>
            <ul className="space-y-2.5 text-sm">
              {categories.slice(0, 5).map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category?genre=${encodeURIComponent(category.name)}`}
                    className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">友情链接</h4>
            <ul className="space-y-2.5 text-sm">
              <li><span className="text-background-300 cursor-pointer hover:text-accent-400 transition-colors">影视观察周刊</span></li>
              <li><span className="text-background-300 cursor-pointer hover:text-accent-400 transition-colors">剧集数据研究所</span></li>
              <li><span className="text-background-300 cursor-pointer hover:text-accent-400 transition-colors">角色志</span></li>
              <li><span className="text-background-300 cursor-pointer hover:text-accent-400 transition-colors">青年导演计划</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 上司的老婆 · 影视剧内容站 · 本站内容均为演示数据，仅供页面展示使用</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">服务条款</Link>
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">版权声明</Link>
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}